<split-sheet-modal [name]="MODAL_NAME" [loading]="sending">
  <div class="send-modal flex h-full flex-column justify-content-center align-items-center">

    <h2 class="text-color-secondary mb-4 text-center">
      Enviar solicitação de emissão de notas fiscais
    </h2>

    <ng-container *ngIf="item">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="send-modal__info flex justify-content-between mb-3 gap-3">
          <span>Profissional: <span class="text-primary font-medium" appCamelCaseText>{{ item.professionalName }}</span></span>
          <span>Mês: <span class="text-primary font-medium">{{ dateRange.start | date: 'MM/yyyy' }}</span></span>
        </div>

        <p class="my-4 text-color-secondary line-height-3">
          Enviaremos um anexo com os atendimentos realizados pelo profissional
          no mês selecionado por email.
        </p>

        <div class="p-fluid grid send-modal__fields">
          <div class="col-12 md:col-4">
            <p-dropdown
              appendTo="body"
              placeholder="Conteúdo de envio"
              [options]="onlyPendingOptions"
              optionLabel="label"
              optionValue="value"
              inputId="onlyPending"
              formControlName="onlyPending">
            </p-dropdown>
            <small
              *ngIf="form.controls.onlyPending.touched && form.controls.onlyPending.hasError('required')"
              class="p-error block mt-1">
              Selecione o conteúdo de envio.
            </small>
          </div>

          <div class="col-12 md:col-8">
            <input
              class="w-full"
              formControlName="mail"
              placeholder="Email"
              type="email"
              pInputText />
            <small
              *ngIf="form.controls.mail.touched && form.controls.mail.invalid"
              class="p-error block mt-1">
              Informe um email válido.
            </small>
          </div>
        </div>

        <div class="send-modal__footer flex justify-content-center mt-5">
          <p-button
            type="submit"
            label="Confirmar envio"
            [disabled]="form.invalid">
          </p-button>
        </div>
      </form>
    </ng-container>

  </div>
</split-sheet-modal>
